"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Join the route paths.
 * @param strArray
 * @returns string
 */
function joinPath() {
    var strArray = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        strArray[_i] = arguments[_i];
    }
    if (strArray.length === 0) {
        return '';
    }
    var resultArray = [];
    var filterStrArray = strArray.filter(function (str) { return str !== ''; });
    filterStrArray.forEach(function (str, index) {
        if (typeof str !== 'string') {
            throw new Error("Path must be a string. Received " + str);
        }
        var routePath = str;
        // Fork from https://github.com/jfromaniello/url-join@4.0.1
        if (index > 0) {
            routePath = routePath.replace(/^[/]+/, '');
        }
        if (index < filterStrArray.length - 1) {
            // Removing the ending slashes for each component but the last.
            routePath = routePath.replace(/[/]+$/, '');
        }
        else {
            // For the last component we will combine multiple slashes to a single one.
            routePath = routePath.replace(/[/]+$/, '/');
        }
        resultArray.push(routePath);
    });
    return resultArray.join('/');
}
exports.default = joinPath;
